import React from 'react';

function CheckList() {
  return (
    <svg
      width='18'
      height='19'
      viewBox='0 0 18 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.25 13.25H15M6 11.75L4.125 14L3 13.25M8.25 9.5H15M6 8L4.125 10.25L3 9.5M8.25 5.75H15M6 4.25L4.125 6.5L3 5.75'
        stroke='black'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default CheckList;
